'use strict';

const TYPE_COUNTRY = 'country';
const TYPE_ADM1 = 'administrative_area_level_1'; // regione
const TYPE_ADM2 = 'administrative_area_level_2'; // provincia
const TYPE_ADM3 = 'administrative_area_level_3'; // comune
const TYPE_POSTAL_CODE = 'postal_code';

export const extractAddressComponent = (components, type) => {
    for (const component of components) {
        if (component.types.includes(type)) {
            return component;
        }
    }
};

export const extractReverseGeocoding = (input) => {
    for (const row of input) {
        const country = extractAddressComponent(row.address_components, TYPE_COUNTRY);
        const adm1 = extractAddressComponent(row.address_components, TYPE_ADM1);
        const adm2 = extractAddressComponent(row.address_components, TYPE_ADM2);
        const adm3 = extractAddressComponent(row.address_components, TYPE_ADM3);
        const postalCode = extractAddressComponent(row.address_components, TYPE_POSTAL_CODE);

        if (country && adm1) {
            return {
                country: country.short_name,
                adm1: adm1.short_name,
                adm2: adm2 && adm2.short_name,
                adm3: adm3 && adm3.short_name,
                postalCode: postalCode && postalCode.short_name,
            };
        }
    }
};
